import { render, staticRenderFns } from "./formScan2X.vue?vue&type=template&id=06695a8e&scoped=true"
import script from "./formScan2X.vue?vue&type=script&lang=js"
export * from "./formScan2X.vue?vue&type=script&lang=js"
import style0 from "./formScan2X.vue?vue&type=style&index=0&id=06695a8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06695a8e",
  null
  
)

export default component.exports